var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.506,
    height: 28.506,
    viewBox: "0 0 28.506 28.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-person-2157037",
    d: "M18.5,4.247A14.253,14.253,0,1,0,32.752,18.5,14.269,14.269,0,0,0,18.5,4.247Zm0,26.68a12.39,12.39,0,0,1-8.935-3.8,10.676,10.676,0,0,1,5.844-4.354,7.135,7.135,0,1,1,6.451,0,10.681,10.681,0,0,1,5.732,4.189A12.392,12.392,0,0,1,18.5,30.927Z",
    transform: "translate(-4.246 -4.247)",
    fill: "#4b4b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.a91ac414b87a8cc6927ff1c522c6001c.svg";
export { ForwardRef as ReactComponent };